import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate } from 'react-router-dom'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    supabase.auth.onAuthStateChange(async (event) => {
      if (event === 'PASSWORD_RECOVERY') {
        // User is in password recovery mode - good
      }
    })
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== confirm) { setError('Passwords do not match'); return }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return }
    setLoading(true)
    setError('')

    const { error } = await supabase.auth.updateUser({ password })
    if (error) { setError(error.message); setLoading(false); return }
    setDone(true)
    setLoading(false)
    setTimeout(() => navigate('/login'), 2000)
  }

  return (
    <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #3730a3 100%)', padding: '1.5rem', paddingTop: 'max(1.5rem, env(safe-area-inset-top))' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '2rem 2rem 1.5rem', background: 'linear-gradient(135deg, #6366f1, #4f46e5)' }}>
          <p style={{ fontWeight: 800, fontSize: 20, color: 'white', letterSpacing: -0.5, margin: '0 0 1rem' }}>Complete PT</p>
          <p style={{ fontSize: 24, fontWeight: 700, color: 'white', lineHeight: 1.2, letterSpacing: -0.5, margin: '0 0 0.5rem' }}>New password</p>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, margin: 0 }}>Choose a new password for your account</p>
        </div>

        <div style={{ padding: '2rem' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: '1rem' }}>✅</div>
              <p style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 16, marginBottom: 8 }}>Password updated</p>
              <p style={{ fontSize: 14 }}>Redirecting you to sign in...</p>
            </div>
          ) : (
            <>
              {error && <div className="alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div className="form-field">
                  <label className="form-label">New password</label>
                  <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
                </div>
                <div className="form-field">
                  <label className="form-label">Confirm password</label>
                  <input type="password" placeholder="••••••••" value={confirm} onChange={e => setConfirm(e.target.value)} required />
                </div>
                <button type="submit" disabled={loading} style={{ marginTop: 4, padding: 14, fontSize: 15 }}>
                  {loading ? 'Updating...' : 'Update password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
